// Potential future work: move these links into the shared vendor logo registry tracked in
// https://github.com/github/marketing-engineering/issues/5515.
const tileLinks = {
  'Eclipse IDE': 'https://marketplace.eclipse.org/content/github-copilot#details',
  GitHub: 'https://github.com/copilot',
  JetBrains: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
  Neovim: 'https://github.com/github/copilot.vim',
  Raycast: 'https://gh.io/copilot-raycast-docs',
  'Visual Studio': 'https://visualstudio.microsoft.com/github-copilot',
  'Visual Studio Code': 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
  Xcode: 'https://github.com/github/CopilotForXcode',
} satisfies Record<string, string>

function hasTileLink(name: string): name is keyof typeof tileLinks {
  return Object.hasOwn(tileLinks, name)
}

export function getTileLink(name: string): string | undefined {
  return hasTileLink(name) ? tileLinks[name] : undefined
}
